<template>
    <div class="cart-item-description" :class="customClass">
        <strong class="cart-item-description__title" v-text="$ml.get('productOrServiceDescription')" tabindex="0" />
        <span v-if="!isShortened" class="cart-item-description__text" tabindex="0">{{ firstItemDescription }}</span>
        <span v-else class="cart-item-description__text" tabindex="0">{{ showFirstItemFullDescription ?
            firstItemDescription : firstItemShortDescription }}</span>

        <button
            @click="handleDescriptionCTA"
            class="cart-item-description__cta"
            v-if="isShortened"
            :aria-label="$ml.get('ariaShowDescription')"
        >
            {{ showFirstItemFullDescription ? $ml.get('hideDescription') : $ml.get('showDescription') }}
            <img
                class="cart-item-description__cta-icon"
                :class="{ active: showFirstItemFullDescription }"
                src="@/assets/img/icons/arrow-down-blue.svg"
                alt=""
                tabindex="-1"
            />
        </button>
    </div>
</template>

<script>

export default {
    data() {
        return {
            firstItemDescription: '',
            maxNumberOfCharacters: 143,
            showFirstItemFullDescription: false,
        };
    },

    props: {
        isShortDescription: {
            type: Boolean,
            default: false
        },
        itemDescription: {
            type: String,
            default: '',
            required: true
        },
        customClass: {
            type: String,
            default: ''
        }
    },

    created() {
        this.firstItemDescription = this.itemDescription.replaceAll('|', '\n').trim();
    },

    computed: {

        firstItemShortDescription() {
            const str = this.itemDescription.slice(0, this.maxNumberOfCharacters) + '...';

            return str.replaceAll('|', '\n').trim();
        },
        isShortened() {
            if (this.isShortDescription) return true;

            return false;
        }
    },

    methods: {
        handleDescriptionCTA() {
            this.showFirstItemFullDescription = !this.showFirstItemFullDescription;
        },


    },
};
</script>

<style lang="scss" scoped>
.cart-item-description {

    //Custom Class
    &.order-status {
        .cart-item-description {
            &__title {
                font-weight: 700;
                line-height: 11px;
                color: #2F363E;
                margin-bottom: 8px;
            }

            &__text {
                color: #5C6A7B;
            }
        }
    }

    &__title {
        font-size: 16px;
        font-weight: 600;
        line-height: 16px;
        color: #000;
        margin-bottom: 20px;
        display: block;
    }

    &__text {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #000;
        display: block;
        white-space: pre-line;
    }

    &__cta {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-decoration: underline;
        color: #0667CD;
        margin: 16px 0 0;

        //btn reset
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;

    }

    &__cta-icon {
        margin-left: 8px;

        &.active {
            transform: rotate(180deg);
        }
    }
}
</style>
